module.exports = __webpack_public_path__ + "static/media/adesivo_bickelkoh.9dd5e185.png";